// extracted by mini-css-extract-plugin
export default {"menu":"ViewportDropdown_menu__SF79D","menuHidden":"ViewportDropdown_menuHidden__A2QME"};